'use client'

import { useRouter } from '@/lib/next-shim'
import { t } from '@lingui/core/macro'

import { useDeleteOrderMutation, GetMyInfosDocument } from '@/core/graphql/hooks'
import { useCallback } from 'react'

/**
 * Encapsulates cancelling a tracked order: confirmation prompt, the
 * deleteOrder mutation (refetching myInfos so the dashboard is up to date),
 * and the redirect back to the dashboard on success.
 */
export function useCancelOrder(orderId: string) {
  const router = useRouter()

  const [deleteOrder, { loading: isCanceling }] = useDeleteOrderMutation({
    refetchQueries: [{ query: GetMyInfosDocument }],
    awaitRefetchQueries: true,
  })

  const cancelOrder = useCallback(async () => {
    if (!confirm(t`Are you sure you want to cancel this appointment?`)) return
    try {
      await deleteOrder({ variables: { orderId } })
      router.push('/account/dashboard')
    } catch (e) {
      console.error(e)
    }
  }, [orderId])

  return [cancelOrder, isCanceling] as const
}
